<template>
  <div class="row" style="padding: 12px;">
    <div class="col-4">
      <add-email-configuration-form
        @on-email-recipient-added="getEmailRecipients()"
      ></add-email-configuration-form>
    </div>
    <div class="col-8">
      <email-recipient-list
        :recipients="recipients"
        @on-delete-recipient="handleRecipientDeleted"
      ></email-recipient-list>
    </div>
  </div>
</template>

<script>
import AddEmailConfigurationForm from '../../../components/CampaignTools/EmailConfiguration/AddEmailConfigurationForm';
import EmailRecipientList from '../../../components/CampaignTools/EmailConfiguration/EmailRecipientList.vue';
import EmailRecipientServiceV2 from '../../../services/V2/EmailRecipientServiceV2';

export default {
  data() {
    return {
      recipients: [],
    };
  },
  components: {
    AddEmailConfigurationForm,
    EmailRecipientList,
  },
  methods: {
    async getEmailRecipients() {
      try {
        const response = await EmailRecipientServiceV2.getEmailRecipients();
        if (response && response.data && response.data.data) {
          this.recipients = response.data.data;
        }
      } catch (error) {
        this.$swal({
          title: 'Error',
          text: 'Failed to fetch email recipients.',
          icon: 'error',
        });
      }
    },
    async handleRecipientDeleted(recipient) {
      try {
        const confirmed = await this.$swal({
          type: 'warning',
          title: 'Delete Recipient?',
          text: `Are you sure you want to delete ${recipient.email} under ${
            recipient.type
          } type?`,
          showCancelButton: true,
          confirmButtonText: 'Yes',
        });

        if (confirmed && confirmed.dismiss) {
          return;
        }

        const response = await EmailRecipientServiceV2.deleteEmailRecipient(
          recipient.id
        );
        if (response && response.status === 204) {
          this.$swal({
            title: 'Success',
            text: `Deleted email recipient: ${recipient.email}`,
            icon: 'success',
          });
          this.getEmailRecipients();
        }
      } catch (error) {
        this.$swal({
          title: 'Error',
          text: 'Failed to delete email recipient.',
          icon: 'error',
        });
      }
    },
  },
  mounted() {
    this.getEmailRecipients();
  },
};
</script>
